import { useElement } from '@nzyme/vue';

export function useScrollToElement() {
    const element = useElement();

    return function (opts: ScrollIntoViewOptions) {
        const el = element.value;
        if (el) {
            el.scrollIntoView(opts);
        }
    };
}
